import { usePhone } from '@modules/phone/hooks/use-phone';
import { useDeviceStore } from '@modules/phone/store/device.store';
import { capitalizeFirst } from '@shared/utils/capitalize';
import { notification } from 'antd';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { RiWifiFill, RiWifiOffFill } from 'react-icons/ri';

export function useNetworkDetector() {
  const { closePhone } = usePhone();
  const { call } = useDeviceStore();
  const { t } = useTranslation();
  let controller = new AbortController();

  useEffect(() => {
    function onOnline() {
      notification.info({
        message: capitalizeFirst(t('connection_successfully_restored')),
        icon: <RiWifiFill color="green" />,
        className: 'connection-online',
        placement: 'bottomLeft',
        closeIcon: <></>,
      });
    }

    function onOffline() {
      if (call) closePhone();
      controller.abort(); // Cancels all requests with this signal
      controller = new AbortController();

      notification.open({
        message: capitalizeFirst(t('calilio_trying_to_reconnect')),
        icon: <RiWifiOffFill color="grey" />,
        className: 'connection-offline',
        placement: 'bottomLeft',
        closeIcon: <></>,
      });
    }

    window.addEventListener('offline', onOffline);
    window.addEventListener('online', onOnline);
    return () => {
      window.removeEventListener('offline', onOffline);
      window.removeEventListener('online', onOnline);
    };
  });
}
